export default __webpack_public_path__ + "static/image1-34133d3af298686bac8ba596a28f0920.jpeg";